import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { links } from '~/links.js'

export const useNavigateWithReferrer = (): (() => void) => {
  const { state } = useLocation()
  const navigate = useNavigate()

  return useCallback(() => {
    navigate(state?.referrer ?? links.preferencesLink(), { state: { ...state, referrer: undefined } })
  }, [navigate, state])
}
